<template>
    <div>
        <b-form-group
            description="Label in select box. Value is tied to foreign key for related component"
            label="Label"
            :label-cols="3"
            :horizontal="false"
        >
            <v-select
                taggable
                :options="labels"
                v-model="field.constraints.relation.label"
                >
            </v-select>
         </b-form-group>

         <b-form-group
            description="Fields that will be included when search is performed"
            label="Search on"
            :label-cols="3"
            :horizontal="false"
        >
            <v-select
                :options="searchOnFields"
                multiple
                v-model="field.constraints.relation.searchOn"
            />
         </b-form-group>


        <RenderEvent 
            event="identityfield_settings_select_relation_constraints" 
            v-model="field.constraints.integrations" 
            :field="field"
        />
    </div>
</template>
<script>
import RenderEvent from '../../../integrations/RenderEvent.vue'
import vSelect from 'vue-select'
import { uniq } from 'lodash'

export default {
    components: {
        RenderEvent,
        vSelect
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: Object
        }
    },
    data: function() {
        return {
            foreignFields: [],
            labels: [],
            searchOnFields: []
        }
    },
    mounted() {
        this.labels.push(this.field.constraints.relation.label)
        this.labels = uniq(this.labels) 
        
        this.$store.dispatch("fetchComponentsSettings", this.field.relation.foreign).then(settings => {
            let fields = settings.settings.fields.filter(f => {
                return f.relation.foreign == ""
            })
            // filter just fields that aren't in relation with another component
            // this.foreignFields = fields.filter(f => {
            //     return f.relation.foreign == ""
            // })

            this.labels = fields.map(f => {
                return f.key.toLowerCase()
            })

            this.labels.push("uuid")

            this.searchOnFields = fields.filter(f => {
                return f.key != this.field.constraints.relation.label
            }).map(f => {
                // if (f.relation.foreign != "") {
                //     let foreign = await this.$store.dispatch("fetchComponentsSettings", f.relation.foreign)
                //     let primaryKey = f.relation.key[0]
                   
                //     this.searchOnFields = foreign.settings.fields.map(f => {
                //         return primaryKey + "." + f.key
                //     }) 
                // }

                return f.key.toLowerCase()
            })
        })
        
    }
}
</script>